import * as Sentry from "@sentry/react";
import { classifyNetworkError } from "@common/lib/sentryUtils";

/** For AVImark calls made with `silent: true`: the caller handles the UI, this keeps the failure visible in Sentry. */
export function reportAvimarkError(error: unknown, where: string): void {
    Sentry.captureException(error, {
        tags: { errorCategory: classifyNetworkError(error), avimarkArea: where },
    });
}
